export const localStorageHelper = {
    getItems(storageKey: string) {
        const result = localStorage.getItem(storageKey) ? JSON.parse(localStorage.getItem(storageKey)) : null;
        if (result) {
            return result;
        }
        return null;
    },
    getItem(storageKey: string, attributeName: string) {
        const result = JSON.parse(localStorage.getItem(storageKey));
        if (result) {
            /*
                if data expireTime is less then current time
                means item has expired,
                in this case removing the item using the key
                and return the null.
            */
            const item = result[attributeName];
            if (item) {
                if (item.expireTime > -1 && item.expireTime <= Date.now()) {
                    result[attributeName] = null;
                    localStorage.setItem(storageKey, JSON.stringify(result));
                    return null;
                } else {
                    return item.value;
                }
            }
            // else return null.
            return null;
        }
        //if there is no data provided the key, return null.
        return null;
    },
    setItem(storageKey: string, attributeName: string, value: any, maxAge = -1) {
        let result = JSON.parse(localStorage.getItem(storageKey));

        const newData: any = {
            value: value,
            expireTime: maxAge == -1 ? maxAge : Date.now() + maxAge
        };

        if (!result) {
            result = {};
        }

        result[attributeName] = newData;

        // Storing the value in object.
        localStorage.setItem(storageKey, JSON.stringify(result));
    },
    removeItem(key: string) {
        localStorage.removeItem(key);
    },
    clear() {
        localStorage.clear();
    }
};
